import { EventEmitter } from 'pixi.js';

export class TypedEventBus<T> {
    // В v8 ми створюємо екземпляр класу EventEmitter напряму
    private emitter = new EventEmitter();

    emit<K extends keyof T>(event: K, data: T[K]): void {
        // Ми приводимо event до string, бо EventEmitter очікує string | symbol
        this.emitter.emit(event as string, data);
    }

    on<K extends keyof T>(event: K, fn: (data: T[K]) => void): void {
        this.emitter.on(event as string, fn);
    }

    off<K extends keyof T>(event: K, fn: (data: T[K]) => void): void {
        this.emitter.off(event as string, fn);
    }

    destroy(): void {
        this.emitter.removeAllListeners();
    }
}